/**
 * 登录
*/
import http from '@/request/http'
export default {
  login: params => http.post(`/api/auth/login`, params),
  getUser: params => http.get(`/api/juji/user/settings`, params),
  loginGetImgCode: params => http.get(`/api/juji/noauth/captcha`, params),//获取图形验证码
  loginGetSMSCode: params => http.get(`/api/juji/sms/noauth/captcha`, params),//未登录状态获取短信验证码
  loginSendChangePassword: params => http.post(`/api/juji/noauth/changePassword`, params),//未登录状通过手机号修改密码
  loginSendSMSCodeBySelf: params => http.get(`/api/juji/sms/captcha/self`, params),//登录状态下给原手机号发送短信验证码
  loginSendSMSCodeByNewPhone: params => http.get(`/api/juji/sms/captcha/new`, params),//登录状态下给新手机号发送短信验证码
  loginModifyPhone: params => http.post(`/api/juji/auth/changePhone`, params),//登录状态下修改手机号
  loginModifyPassword: params => http.post(`/api/auth/changePassword
  `, params),//登录状态下旧密码修改新密码
  loginModifyPasswordByPhone: params => http.post(`/api/juji/auth/changePassword`, params),//登录状态下用手机验证码修改密码
  refreshTokenPost: params => http.post(`/api/auth/token`, params),
}

